import { useCallback, useMemo } from 'react';
import { store } from 'redux/store';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroWBCultureSelectedCultureCP,
  setCultureCP,
} from 'redux/reducers/meteorologyAgroWBCultureReducer';
import useOptions from './useOptions';

export default function useCulture() {
  const { options } = useOptions();
  const availableCultures = useMemo(() => options?.cultures, [options]);

  const selectedCulture = useSelector(selectMeteorologyAgroWBCultureSelectedCultureCP);
  const setCulture = useCallback((c: number) => {
    store.dispatch(setCultureCP(c));
  }, []);

  return {
    availableCultures,
    selectedCulture,
    setCulture,
  };
}
